"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokenUtilities = void 0;
var jwt = require('jsonwebtoken');
exports.tokenUtilities = {
    /**
     * @param token A jwt token
     * @returns true if it is one of our tokens
     */
    isIgToken: function (token) {
        var _a;
        var decodedToken = jwt.decode(token, { complete: true });
        if (!decodedToken) {
            return false;
        }
        if (((_a = decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken.payload) === null || _a === void 0 ? void 0 : _a.aud) === 'Incentive Games') {
            return true;
        }
        return false;
    }
};
